<template>
    <div class="animated-line-chart">
        <ECharts :option="getOptions()" class="echart-graph" />
    </div>
</template>
<script>
import Vue from "vue";
import { createComponent, plugin } from "echarts-for-vue";
import * as echarts from "echarts/lib/echarts";
import "echarts/lib/chart/heatmap";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/grid";
import "echarts/lib/component/visualMap";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markLine";
import { LineChart } from "echarts/charts";
import _ from "lodash";

echarts.use([LineChart]);

Vue.use(plugin, { echarts });
//https://echarts.apache.org/examples/en/editor.html?c=line-race
export default Vue.extend({
    name: "AnimatedLineChart",
    components: {
        ECharts: createComponent({ echarts }),
    },
    props: {
        title: {
            type: String,
            default: "Chart Title",
        },

        legends: {
            type: Array,
            default: () => [],
        },
        xAxisData: {
            type: Object,
        },
        yAxisData: {
            type: Object,
        },
        series: {
            type: Array,
            default: () => [],
        },
        colors: {
            type: Array,
            default: () => [],
        },
        overrideOptions: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        getOptions() {
            const options = _.merge(
                {
                    // color: ["#80FFA5", "#00DDFF", "#37A2FF", "#FF0087", "#FFBF00"],
                    color: this.colors,
                    title: {
                        text: this.title,
                        left: "center",
                        bottom: 20,
                        top: 20,
                    },
                    tooltip: {
                        order: "valueDesc",
                        trigger: "axis",
                        axisPointer: {
                            type: "cross",
                            label: {
                                backgroundColor: "#6a7985",
                            },
                        },
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {},
                        },
                    },
                    grid: {
                        right: 140,
                    },
                    animationDuration: 5000,
                    xAxis: this.xAxisData,
                    yAxis: this.yAxisData,
                    series: this.series,
                },
                this.overrideOptions
            );
            console.log("options", options);
            return options;
        },
    },
});
</script>

<style scoped lang="scss">
.animated-line-chart {
    width: 100%;
    height: 500px;

    .echart-graph {
        width: 100%;
        height: 100%;
    }
}
</style>
